import React from 'react';
import { Card } from 'antd';
import AntdProForm, { ProFormDatePicker } from '@ant-design/pro-form';

const ScheduleForm = () => (
  <Card title="Schedule" style={{ marginBottom: '24px' }}>
    <AntdProForm.Group>
      <ProFormDatePicker
        width="xl"
        name="originalStartDate"
        label="Original Start Date (YYYY-MM-DD)"
        placeholder="Original Start Date"
        rules={[
          { required: true, message: 'Please select original start date!' },
        ]}
      />
      <ProFormDatePicker
        width="xl"
        name="originalCompletionDate"
        label="Original Completion Date (YYYY-MM-DD)"
        placeholder="Original Completion Date"
        rules={[
          {
            required: true,
            message: 'Please select original completion date!',
          },
        ]}
      />
    </AntdProForm.Group>
    <AntdProForm.Group>
      <ProFormDatePicker
        width="xl"
        name="actualStartDate"
        label="Actual Start Date (YYYY-MM-DD)"
        placeholder="Actual Start Date"
      />
      <ProFormDatePicker
        width="xl"
        name="actualCompletionDate"
        label="Actual Completion Date (YYYY-MM-DD)"
        placeholder="Actual Completion Date"
      />
    </AntdProForm.Group>
    <ProFormDatePicker
      width="xl"
      name="deadlineOfUsingUpFunding"
      label="Deadline of Using Up Funding (YYYY-MM-DD)"
      placeholder="Deadline of Using Up Funding"
      rules={[
        {
          required: true,
          message: 'Please select deadline of using up funding!',
        },
      ]}
    />
  </Card>
);

export default ScheduleForm;
